// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"Feedback-module--subtitle--eSX2O","social":"Feedback-module--social--243tN","title":"Feedback-module--title--HcB7W"};